module.exports = __webpack_public_path__ + "img/icb-co-elite-e@2x.e0a4d48e.png";